import './libraries/slimmageSettings';
import './libraries/slimmage';
import Fader from './libraries/fader';

// App
import App from './app';
import PolyfillController from './controllers/polyfill';

// Controllers
import HeaderController from './controllers/header';
import MediaController from './controllers/media';
import ConsentController from '@humandigital-agency/consent-controller';
import ToastController from './controllers/toast/controller';
import SliderController from './controllers/slider';
import ProductColorSwitchController from './controllers/productColorSwitch';
import ProductSelectorController from './controllers/productSelector/controller';
// import MasonryGridController from './controllers/masonrygrid/controller';
// import InspirationGridController from './controllers/inspirationGrid/controller';
import ProductDetailColorSwitchController from './controllers/productDetailColorSwitch/controller';
import BlogoverviewController from './controllers/blogoverview/controller';
import ParallaxController from './controllers/parallax';

(async () => {
    document.querySelector('html').classList.remove('no-js');

    const polyfills = new PolyfillController();
    await polyfills.init();

    try {
        const app = new App();
        app.resizeThrottle = 10;
        app.scrollThrottle = 100;
        window.app = app;

        app.polyfillController = polyfills;

        app.ConsentController = new ConsentController();
        app.headerController = new HeaderController();
        app.mediaController = new MediaController();
        app.sliderController = new SliderController();
        app.productColorSwitchController = new ProductColorSwitchController();
        app.toastController = new ToastController();
        app.productDetailColorSwitchController = new ProductDetailColorSwitchController();
        app.productSelectorController = new ProductSelectorController();
        app.BlogoverviewController = new BlogoverviewController();
        app.parallaxController = new ParallaxController();
 
        // Disabled masonry grid on blogoverview
        // if (document.querySelector('.blogOverviewContainer')) {
        //     import( /* webpackChunkName: "modules/masonrygrid" */ './controllers/masonrygrid/controller').then(e => {
        //         app.masonryGridController = new e.default();
        //     });
        // }

        if (document.querySelector('ol.inspirationContainer')) {
            import( /* webpackChunkName: "modules/inspirationgrid" */ './controllers/inspirationGrid/controller').then(e => {
                app.inspirationGridController = new e.default();
            });
        }

        // Modules
        if (document.querySelector('.shareContainer')) {
            import( /* webpackChunkName: "modules/share" */ './controllers/share/controller').then(e => {
                app.shareController = new e.default();
            });
        }

        if (document.querySelector('.dealerLocatorContainer')) {
            import( /* webpackChunkName: "modules/dealerLocator" */ './controllers/dealerLocator/controller').then(e => {
                app.dealerLocatorController = new e.default();
            });
        }

        if (document.querySelector('.experienceLocatorContainer')) {
            import( /* webpackChunkName: "modules/experienceLocator" */ './controllers/experienceLocator/controller').then(e => {
                app.experienceLocatorController = new e.default();
            })
        }

        if (document.querySelector('ul.accordeon:not(.locked), ol.accordeon:not(.locked), div.accordeon:not(.locked)')) {
            import( /* webpackChunkName: "modules/accordeon" */ './controllers/accordeon/controller').then(e => {
                app.accordeonController = new e.default();
            });
        }

        if (document.querySelector('.sunscienceOverview')) {
            import( /* webpackChunkName: "modules/sunscienceOverview" */ './controllers/sunscienceOverview').then(e => {
                app.sunscienceOverviewController = new e.default();
            });
        }

        // if (document.querySelector('.swiper-container')) {
        //     import( /* webpackChunkName: "modules/sunscienceOverview" */ './controllers/slider').then(e => {
        //         app.sliderController = new e.default();
        //     });
        // }

        // if (document.querySelector('.blogOverviewContainer')) {
        //     import( /* webpackChunkName: "modules/blogoverview" */ './controllers/blogoverview/controller').then(e => {
        //         app.BlogoverviewController = new e.default();
        //     })
        // }

        // if (document.querySelector('.productOverviewContainerController')) {
        //     import( /* webpackChunkName: "modules/productColorSwitch" */ './controllers/productColorSwitch').then(e => {
        //         app.productColorSwitchController = new e.default();
        //     })
        // }

        // if (document.querySelector('.productDetailHeroContainer')) {
        //     import( /* webpackChunkName: "modules/productDetailColorSwitch" */ './controllers/productDetailColorSwitch/controller').then(e => {
        //         app.productDetailColorSwitchController = new e.default();
        //     })
        // }

        // if (document.querySelector('.swiper-container')) {
        //     import( /* webpackChunkName: "modules/slider" */ './controllers/slider').then(e => {
        //         app.sliderController = new e.default();
        //     })
        // }

        // Fade functionality

        const fades = [];
        fades.push('#heroLarge');
        fades.push('.heroCta');
        fades.push('.column-1');
        fades.push('.column-2');
        fades.push('.column-3');
        fades.push('.fadeElement');
        fades.push('.productOverviewContainer');
        fades.push('.fullImageContactContainer');
        fades.push('.contactDetailsContainer');
        fades.push('article');

        let loadFader;
        loadFader = () => {
            if (document.querySelector('.hero img')) {
                const image = document.querySelector('.hero img');
                if (image.complete && image.naturalHeight !== 0) {
                    app.fader = app.fader || new Fader(fades.join(','));
                } else {
                    image.onload = () => {
                        app.fader = app.fader || new Fader(fades.join(','));
                    }
                }
            } else {
                app.fader = app.fader || new Fader(fades.join(','));
            }

            ['slimmageNewImages', 'slimmageNoImages'].forEach(eventName => {
                document.removeEventListener(eventName, loadFader.bind(this));
            });

        };

        ['slimmageNewImages', 'slimmageNoImages'].forEach(eventName => {
            document.addEventListener(eventName, loadFader.bind(this));
        });


        await app.init();
        console.log(`App initialized`);
        document.documentElement.classList.remove('preventAnimations');

    } catch (e) {
        console.error(`Something went wrong initializing the app`);
        document.documentElement.classList.remove('preventAnimations');
        throw e;
    };

})();